import { NgModule } from '@angular/core';
import { I18nDirective } from './i18n.directive';

@NgModule({
  declarations: [I18nDirective],
  exports: [I18nDirective]
})
export class I18nModule { }
